import * as React from 'react';
import { FilterContext, IFilter } from './FilterContext';
import { set } from 'date-fns';

interface IProps {
  children?: React.ReactNode;
}

const Filter = (props: IProps) => {
  const [mustLoadSystems, setMustLoadSystems] = React.useState(true);
  const [activeSystems, setActiveSystems] = React.useState([] as number[]);

  const value = {
    mustLoadSystems: mustLoadSystems, 
    setMustLoadSystems: setMustLoadSystems,
    activeSystems: activeSystems,
    setActiveSystems: setActiveSystems
  }

  return (
    <FilterContext.Provider value={value}>
      {props.children}
    </FilterContext.Provider>
  );
}

export { Filter }
